import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el ebook?',
  answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con un enlace seguro para descargar el ebook y todos los bonos en formato PDF. Puedes acceder a ellos desde cualquier dispositivo.'
}, {
  question: '¿Es digital?',
  answer: 'Sí, es un producto 100% digital. No se envía ningún producto físico a tu domicilio, lo que te permite tener acceso inmediato y llevar las recetas contigo en tu celular al supermercado o la cocina.'
}, {
  question: '¿Necesito experiencia cocinando?',
  answer: '¡Para nada! Todas las recetas están diseñadas paso a paso, de forma clara y sencilla. Son a prueba de principiantes y no requieren técnicas culinarias complejas.'
}, {
  question: '¿Las recetas son caras?',
  answer: 'No. Uno de los pilares de este recetario es usar ingredientes accesibles y comunes que encuentras en cualquier supermercado local. Además, incluye una guía para comprar económico.'
}, {
  question: '¿Funciona para perder grasa?',
  answer: 'Sí, absolutamente. Todas las recetas tienen los macronutrientes calculados y están diseñadas para ser altas en proteína y moderadas en calorías, lo que facilita mantener un déficit calórico sin pasar hambre.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-28 bg-lightGreen" data-id="element-34">
      <div className="container mx-auto px-4" data-id="element-35">
        <div className="text-center mb-16 md:mb-20" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-6 font-montserrat uppercase" data-id="element-37">
            Preguntas <span className="text-vibrantGreen" data-id="element-38">Frecuentes</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-40">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-41">
                <span className="font-bold text-darkGreen text-lg pr-4" data-id="element-42">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-vibrantGreen transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-43" />
              </button>

              <AnimatePresence data-id="element-44">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-45">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-46">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}